import { featuredStories } from '@/mocks/home';

export default function FeaturedStory() {
  return (
    <section id="featured" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-center gap-3">
          <span className="h-6 w-1.5 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            置顶爆料
          </h2>
          <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
            封面对开
          </span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <article className="group relative cursor-pointer overflow-hidden rounded-2xl bg-background-200 lg:col-span-7">
            <div className="relative aspect-[16/11] w-full lg:aspect-[16/10]">
              <img
                src={featuredStories.cover}
                alt="置顶爆料封面"
                title="51黑料网 置顶爆料 明星爆料"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50 dark:text-foreground-950">
                <i className="ri-pushpin-2-fill"></i>
                {featuredStories.badge}
              </span>
              <h3 className="mt-3 font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
                {featuredStories.title}
              </h3>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/90">
                {featuredStories.excerpt}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-background-100/80">
                {featuredStories.stats.map((s) => (
                  <span key={s} className="whitespace-nowrap">
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </article>

          <div className="flex flex-col lg:col-span-5">
            <div className="mb-4 flex flex-wrap gap-2">
              {featuredStories.tags.map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700"
                >
                  #{t}
                </span>
              ))}
            </div>
            <div className="flex flex-1 flex-col divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-50">
              {featuredStories.list.map((item, idx) => (
                <a
                  key={item.id}
                  href="#timeline"
                  className="group flex cursor-pointer items-start gap-4 p-5 transition-colors hover:bg-background-100"
                >
                  <span className="font-heading text-2xl font-black text-background-300 transition-colors group-hover:text-primary-400">
                    0{idx + 1}
                  </span>
                  <span className="flex-1">
                    <span className="block text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="mt-2 block text-xs text-foreground-500">{item.meta}</span>
                  </span>
                  <i className="ri-arrow-right-line mt-1 text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500"></i>
                </a>
              ))}
            </div>
            <a
              href="#timeline"
              className="mt-4 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
            >
              查看全部今日黑料
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}